import React, { useEffect, useRef, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import Utils from "../Utils";
import ContextComponent from "../AppContext";
import "../../assets/css/login.css";
import LoginLeftBGImg from "../../assets/img/login-bg.png";
import LoginRightBGImg from "../../assets/img/logo-on-white-bg.png";

import {
  Container,
  Card,
  Form,
  Button,
  Modal,
  FloatingLabel,
} from "react-bootstrap";

const LoginForm = () => {
  const HIDDEN_CLASS = "d-none";
  let emailField = useRef(null);
  let userPasswordField = useRef(null);
  let rememberMe = useRef(null);
  let emailErrMsgDiv = useRef(null);
  let userPwdErrMsgDiv = useRef(null);
  let gloablError = useRef(null);
  let {
    setLoadingState,
    setCanRedirectToLanding,
    setCanRedirectToResetPassword,
    setAlert
  } = useContext(ContextComponent);
  let [formErrorMsg, setFormErrorMsg] = useState("");
  let navigate = useNavigate();

  const toggleErrMsgClass = (ele, eleMsg, toggle = true) => {
    if (toggle) {
      eleMsg.current.classList.remove(HIDDEN_CLASS);
    } else {
      eleMsg.current.classList.add(HIDDEN_CLASS);
    }
  };

  const onClickHandler = (e) => {
    e.preventDefault();
    let valid = true;
    let email = emailField.current.value || "";
    let userPwd = userPasswordField.current.value || "";
    if (email.length === 0) {
      toggleErrMsgClass(emailField, emailErrMsgDiv, true);
      valid = false;
    } else {
      toggleErrMsgClass(emailField, emailErrMsgDiv, false);
    }
    if (userPwd.length === 0) {
      toggleErrMsgClass(userPasswordField, userPwdErrMsgDiv, true);
      valid = false;
    } else {
      toggleErrMsgClass(userPasswordField, userPwdErrMsgDiv, false);
    }

    if (valid) {
      const loginSuccess = (res) => {
        setFormErrorMsg("");
        if (res?.redirect) {
          navigate(Utils.APP_URLS.LANDING_PAGE);
        }
      };
      const loginFail = (err) => {
        console.log("login fail error:::", err);
        // setFormErrorMsg(err?.data?.message || "Login failed...");
        //  we modified the above way of setting error because sometimes the error
        //  description is in data.message and sometimes it's in err.data, and if nothing presents
        // we use the default value.
        setFormErrorMsg(
          err?.data?.message
            ? err.data.message
            : err?.data
              ? err.data
              : "Login failed..."
        );
        return false;
      };
      const loginCallback = (response) => {
        setLoadingState({
          applyMask: false,
        });
        if (response.status === 200) {
          if (response.redirectToResetPwd) {
            navigate(Utils.APP_URLS.RESET_PASSWORD_PAGE);
          } else {
            navigate(Utils.APP_URLS.LANDING_PAGE);
            loginSuccess(response);
          }
        } else {
          loginFail(response);
        }
      };
      let params = {
        email: email,
        userPwd: userPwd,
        rememberMe: rememberMe.current.checked,
      };
      setLoadingState({
        applyMask: true,
        text: "Log-in is in progress",
      });
      Utils.executeLoginRESTAPI(params).then(loginCallback, loginFail);
    } else {
      console.log("login form is in-complete...");
    }
  };

  const emailFocusOutEventHandler = (e) => {
    e.preventDefault();
    let email = emailField.current.value || "";
    if (email.length === 0) {
      toggleErrMsgClass(emailField, emailErrMsgDiv, true);
    } else {
      toggleErrMsgClass(emailField, emailErrMsgDiv, false);
    }
  };

  const userPwdFocusOutEventHandler = (e) => {
    e.preventDefault();
    let userPwd = userPasswordField.current.value || "";
    if (userPwd.length === 0) {
      toggleErrMsgClass(userPasswordField, userPwdErrMsgDiv, true);
    } else {
      toggleErrMsgClass(userPasswordField, userPwdErrMsgDiv, false);
    }
  };

  Utils.userSessionExists() && setCanRedirectToLanding(true);

  useEffect(() => { }, []);

  useEffect(() => {
    gloablError.current.classList[
      formErrorMsg?.trim().length ? "remove" : "add"
    ]("d-none");
  }, [formErrorMsg]);

  // let defaultEmailValue = "user_1@company.com";
  // let defaultPwdValue = "user_1";

  let [resetEmailInput, setResetEmailInput] = useState("");
  let [resetFormErrorMsg, setResetFormErrorMsg] = useState("");
  let [disabledProp, setDisabledProp] = useState(true);
  let [modalCanOpen, setModalCanOpen] = useState(false);

  let openResetModal = (event) => {
    event.stopPropagation();
    setModalCanOpen(true);
  };

  let handleClose = (event) => {
    event && event.stopPropagation();
    setModalCanOpen(false);
  };

  let executeResetPassword = (event) => {
    event.stopPropagation();
    setResetFormErrorMsg("");
    //console.log(" on executing reset password... : " + resetEmailInput);

    const resetSuccess = (res) => {
      setResetFormErrorMsg("");
      setAlert({
        show: true,
        message: "Reset password done successfully! Check your registered email inbox.",
      });
      handleClose();
    };
    const failCallback = (err) => {
      setLoadingState({
        applyMask: false,
      });
      setResetFormErrorMsg(err?.response?.data?.message ?? '');
    };
    const successCallback = (response) => {
      setLoadingState({
        applyMask: false,
      });
      if (response.status === 200) {
        resetSuccess(response);
      }
    };
    let params = {
      email: resetEmailInput,
    };
    setLoadingState({
      applyMask: true,
      text: "Resetting password is in progress",
    });
    Utils.executeUserResetPassword(params).then(successCallback, failCallback);
  };

  const inputHandler = (e) => {
    let value = e.currentTarget.value.trim();
    setResetEmailInput(value);
    setDisabledProp(!value.length);
  };

  return (
    <Container className="vh-100 vw-100 p-0 m-0 mw-100 mh-100">
      <Card className="p-0 m-0 w-100 h-100 border-0">
        <Form className="form w-100 h-100 d-flex">
          <div className="indi-login-page-left-side h-100 w-50 overflow-hidden">
            <img
              className="h-100 w-50"
              src={LoginLeftBGImg}
              alt="Welcome to our Digital Business Card Form"
            />
            <div className="vh-100 indi-login-logo-text-wrapper">
              <div className="h-100 indi-login-logo-text align-items-center">
                Welcome to Assess My Risks Admin Platform
              </div>
            </div>
          </div>

          <div className="indi-login-page-right-side w-50 h-100">
            <div className="indi-login-page-right-top-logo">
              <img
                src={LoginRightBGImg}
                className="d-flex justify-content-end"
                alt="digital business cards"
              />
            </div>

            <div className="indi-login-form-wrapper">
              <div className="indi-login-form-headings text-left">
                <div className="indi-login-form-text-login">Log in</div>

                <div className="indi-login-form-text-desc">
                  Please log in to your account.
                </div>
              </div>

              <div className="indi-login-global-error d-none" ref={gloablError}>
                {formErrorMsg}
              </div>

              <div className="indi-login-form">
                <div className="indi-login-form-input-wrapper">
                  <input
                    // className={` ${warnemail ? "indi-login-form-input-warning" : ""}`}
                    className={`indi-login-form-input indi-login-form-input-email`}
                    type="text"
                    placeholder="Enter email"
                    name="email"
                    required
                    ref={emailField}
                    //value={defaultEmailValue}
                    onChange={emailFocusOutEventHandler}
                  />
                  {/* <p className={` ${danger ? "danger" : ""}`}> */}
                  <p ref={emailErrMsgDiv} className="d-none">
                    Please enter a valid email address.
                  </p>
                </div>
                <div className="indi-login-form-input-wrapper">
                  <input
                    // className={` ${warnpass ? "indi-login-form-input-warning" : ""}`}
                    className={`indi-login-form-input indi-login-form-input-password`}
                    type="password"
                    ref={userPasswordField}
                    placeholder="Enter Password"
                    name="password"
                    required
                    //value={defaultPwdValue}
                    onChange={userPwdFocusOutEventHandler}
                  />
                  {/* <p className={` ${danger ? "danger" : ""}`}> */}
                  <p ref={userPwdErrMsgDiv} className="d-none">
                    Please enter password.
                  </p>
                </div>
                <div className="indi-login-remember-reset">
                  <div className="indi-login-remember-wrapper">
                    <input
                      className="form-check-input indi-login-remember-checkbox p-0 m-0"
                      type="checkbox"
                      ref={rememberMe}
                    />
                    <div className="indi-login-remember-label">Remember me</div>
                  </div>
                  <div
                    className="indi-login-reset-wrapper"
                    role="button"
                    onClick={openResetModal}
                  >
                    Reset password?
                    <Modal centered show={modalCanOpen} onHide={handleClose}>
                      <Modal.Header>
                        <Modal.Title>Reset password</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <form>
                          <div className="indi-add-form-wrapper indi-login-reset-form-wrapper d-flex flex-column">
                            <div className="indi-add-form-item d-flex flex-column">
                              <div className="indi-add-form-item-input row">
                                <FloatingLabel label="email">
                                  <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="email"
                                    placeholder="Enter email"
                                    autoComplete="off"
                                    defaultValue={resetEmailInput}
                                    onChange={inputHandler}
                                  />
                                </FloatingLabel>
                              </div>
                            </div>
                          </div>
                          <div className="indi-login-reset-form-error">{resetFormErrorMsg}</div>

                          <div className="indi-add-footer">
                            <div className="indi-add-page-footer-btn-wrapper float-right">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleClose}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                disabled={disabledProp}
                                className="btn btn-primary"
                                onClick={executeResetPassword}
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </form>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>

                <div className="btn w-100 h-100 p-0 indi-login-form-btn-wrapper">
                  <Button
                    className="w-100 m-0 p-0 indi-login-form-btn"
                    type="submit"
                    onClick={onClickHandler}
                  >
                    Login
                  </Button>
                </div>
              </div>
            </div>

            <div className="indi-login-footer-wrapper">
              <div className="indi-login-footer text-uppercase">
                <div className="indi-login-footer-msg-1">worldwide reach,</div>
                <div className="indi-login-footer-msg-2">human touch</div>
              </div>
            </div>
          </div>
        </Form>
      </Card>
    </Container>
  );
};

export default LoginForm;
